import PageEasyWins from './PageEasyWinsContainer';

export default PageEasyWins;
